import logoIcon from '@/assets/hm-logo.png';

interface CompanyLogoProps {
  readonly size?: number;
  readonly className?: string;
}

export function CompanyLogo({ size = 40, className = '' }: CompanyLogoProps) {
  return (
    <div
      className={`rounded-full overflow-hidden bg-white dark:bg-gray-800 flex items-center justify-center flex-shrink-0 ${className}`}
      style={{ width: size, height: size, minWidth: size, minHeight: size }}
    >
      <img
        src={logoIcon}
        alt="Company Logo"
        className="object-contain"
        style={{ width: size * 0.8, height: size * 0.8 }}
      />
    </div>
  );
}
